import React, { useContext } from 'react'
import single_slot_gif from '../../assets/images/single_slot_gif.gif'
import { Link } from 'react-router-dom'
import LoginContext from '../../context'
const SingleSlotCard = () => {

    const {isAuthenticated}= useContext(LoginContext)
    return (
        <>
            
                <Link to="#" className={`inline-block align-middle shadow-[0_0_1px_rgba(0,0,0,0)] relative top-0 left-0 transform-3d-fix ${isAuthenticated ? 'single-slot-card-animation': ''}
                 before:pointer-events-none before:content-[""] before:absolute before:opacity-0 before:duration-[0.3s] before:transition-[top,right,bottom,left] before:border-[#e1e1e1] before:border-solid before:border-[4px] before:-inset-4
                 ${isAuthenticated ? 'hover:before:opacity-100 hover:before:-inset-2 hover:focus:opacity-100  hover:active:opacity-100 ': ''} `}>
                    <img src={single_slot_gif} className="w-full" loading="lazy" />
                    <span className='cursor-pointer bg-[#0009] block w-full text-sm text-center h-[30px] leading-[30px] overflow-hidden mt-1 font-Time'>로얄 러쉬 1000</span>
                </Link>
        </>
    )
}

export default SingleSlotCard